import { OpenInNew } from "@mui/icons-material";
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

export default function MehrOnboarding(props) {
  const { t } = useTranslation();

  const anchorStyle = {
    textDecoration: "none",
    color: "black",
  };

  return (
    <Box>
      <Typography variant="h2" sx={{ mt: 3 }}>
        {t("welcomeMoreTitle")}
      </Typography>
      <Box sx={{ pt: { xs: 2, sm: 3 } }}>
        <Typography align="left" sx={{ mb: 1 }}>
          {t("welcome", { website: "Gekonnt hanDeln" })}
        </Typography>
        <Typography align="left" sx={{ mb: 1 }}>
          {t("welcomeMoreText1")}
        </Typography>
        <List disablePadding>
          <ListItem disablePadding>
            <a
              style={anchorStyle}
              href="https://www.minijob-zentrale.de/DE/die-minijobs/arbeitsrechte-im-minijob/arbeitsrechte-im-minijob_node.html"
              rel="noreferrer"
              target="_blank"
            >
              <ListItemButton>
                <OpenInNew />
                &nbsp;
                <ListItemText
                  primary={t("welcomeMoreText2")}
                  primaryTypographyProps={{ fontWeight: 500 }}
                />
              </ListItemButton>
            </a>
          </ListItem>
          <ListItem disablePadding>
            <a
              style={anchorStyle}
              href="https://www.dguv.de/de/praevention/index.jsp"
              rel="noreferrer"
              target="_blank"
            >
              <ListItemButton>
                <OpenInNew />
                &nbsp;
                <ListItemText
                  primary={t("welcomeMoreText3")}
                  primaryTypographyProps={{ fontWeight: 500 }}
                />
              </ListItemButton>
            </a>
          </ListItem>
          <ListItem disablePadding>
            <a
              style={anchorStyle}
              href="https://www.gkv-spitzenverband.de/service/versicherten_service/praeventionskurse/primaerpraeventionskurse.jsp"
              rel="noreferrer"
              target="_blank"
            >
              <ListItemButton>
                <OpenInNew />
                &nbsp;
                <ListItemText
                  primary={t("welcomeMoreText4")}
                  primaryTypographyProps={{ fontWeight: 500 }}
                />
              </ListItemButton>
            </a>
          </ListItem>
          <ListItem disablePadding>
            <a
              style={anchorStyle}
              href="https://alter-pflege-demenz-nrw.de/akteure/themen/unterstuetzung-im-alltag/"
              rel="noreferrer"
              target="_blank"
            >
              <ListItemButton>
                <OpenInNew />
                &nbsp;
                <ListItemText
                  primary={t("welcomeMoreText5")}
                  primaryTypographyProps={{ fontWeight: 500 }}
                />
              </ListItemButton>
            </a>
          </ListItem>
          <ListItem disablePadding>
            <a
              style={anchorStyle}
              href="https://www.hauswirtschaftsrat.de/"
              target="_blank"
              rel="noreferrer"
            >
              <ListItemButton>
                <OpenInNew />
                &nbsp;
                <ListItemText
                  primary={t("welcomeMoreText6")}
                  primaryTypographyProps={{ fontWeight: 500 }}
                />
              </ListItemButton>
            </a>
          </ListItem>
          <ListItem disablePadding>
            <a
              style={anchorStyle}
              href="https://www.bamf.de/DE/Themen/Integration/AkteureEhrenamtlicheInteressierte/Migrantenorganisationen/migrantenorganisationen-node.html"
              rel="noreferrer"
              target="_blank"
            >
              <ListItemButton>
                <OpenInNew />
                &nbsp;
                <ListItemText
                  primary={t("welcomeMoreText7")}
                  primaryTypographyProps={{ fontWeight: 500 }}
                />
              </ListItemButton>
            </a>
          </ListItem>
        </List>
      </Box>
    </Box>
  );
}
